//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import * as dataSourceApi from '@apis/data-sources/dataSourcesApi';
import { createNgApiAdapterService, GetNgApiAdapterType } from './createNgApiAdapter';

const dataSourceApiService = createNgApiAdapterService(dataSourceApi);

export type DataSourceApiService = GetNgApiAdapterType<typeof dataSourceApiService>;

angular.module('curalate').service('DataSourceApiService', dataSourceApiService);
